import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=7bc83b20&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc83b20')) {
      api.createRecord('7bc83b20', component.options)
    } else {
      api.reload('7bc83b20', component.options)
    }
    module.hot.accept("./Permission.vue?vue&type=template&id=7bc83b20&", function () {
      api.rerender('7bc83b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/Permission.vue"
export default component.exports